export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ20.dd77a929.mp3";